export default "__VITE_ASSET__Dk13tCuD__"